<ng-container *ngIf="!isEditable(isEditMode, isUserPharma, isLocked)">
  <span class="term__value">{{ getTermValue() | booleanChoice: choiceOptions }}</span>
</ng-container>
<ng-container *ngIf="isEditable(isEditMode, isUserPharma, isLocked)">
  <mat-slide-toggle
    [formControl]="control"
    [checked]="control.value"
  ></mat-slide-toggle>
  <span class="term__value term__value--left-offset">{{ control.value | booleanChoice: choiceOptions }}</span>
</ng-container>